/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { DocumentAiContext, useDocumentAiContext } from './document-ai-context'
import type * as Fetcher from './document-ai-fetcher'
import { documentAiFetch } from './document-ai-fetcher'
import type * as Responses from './document-ai-responses'
import type * as Schemas from './document-ai-schemas'

export type DocumentUploadedPathParams = {
  documentId: string
}

export type DocumentUploadedHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentUploadedError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentUploadedVariables = {
  headers?: DocumentUploadedHeaders
  pathParams: DocumentUploadedPathParams
} & DocumentAiContext['fetcherOptions']

/**
 * Notify Document of upload status
 */
export const fetchDocumentUploaded = (variables: DocumentUploadedVariables, signal?: AbortSignal) =>
  documentAiFetch<Schemas.Document, DocumentUploadedError, undefined, DocumentUploadedHeaders, {}, DocumentUploadedPathParams>({
    url: '/documents/{documentId}/uploaded',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Notify Document of upload status
 */
export const useDocumentUploaded = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.Document, DocumentUploadedError, DocumentUploadedVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useDocumentAiContext()
  return reactQuery.useMutation<Schemas.Document, DocumentUploadedError, DocumentUploadedVariables>({
    mutationFn: (variables: DocumentUploadedVariables) => fetchDocumentUploaded({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type BeginDocumentAnalyzePathParams = {
  documentId: string
}

export type BeginDocumentAnalyzeHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type BeginDocumentAnalyzeError = Fetcher.ErrorWrapper<{
  status: 404
  payload: Responses.ErrorEntityNotFound
}>

export type BeginDocumentAnalyzeVariables = {
  headers?: BeginDocumentAnalyzeHeaders
  pathParams: BeginDocumentAnalyzePathParams
} & DocumentAiContext['fetcherOptions']

/**
 * This endpoint is used to start the asynchronous analyze of the document.
 */
export const fetchBeginDocumentAnalyze = (variables: BeginDocumentAnalyzeVariables, signal?: AbortSignal) =>
  documentAiFetch<
    Schemas.BeginAnalyzeResponse,
    BeginDocumentAnalyzeError,
    undefined,
    BeginDocumentAnalyzeHeaders,
    {},
    BeginDocumentAnalyzePathParams
  >({
    url: '/documents/{documentId}/uploaded/analyzeRequest',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * This endpoint is used to start the asynchronous analyze of the document.
 */
export const useBeginDocumentAnalyze = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.BeginAnalyzeResponse, BeginDocumentAnalyzeError, BeginDocumentAnalyzeVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useDocumentAiContext()
  return reactQuery.useMutation<Schemas.BeginAnalyzeResponse, BeginDocumentAnalyzeError, BeginDocumentAnalyzeVariables>({
    mutationFn: (variables: BeginDocumentAnalyzeVariables) => fetchBeginDocumentAnalyze({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type AsyncAnalyzedResultPathParams = {
  operationId: string
  documentId: string
}

export type AsyncAnalyzedResultHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type AsyncAnalyzedResultError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
  | {
      status: 409
      payload: Responses.ErrorEntityConflict
    }
>

export type AsyncAnalyzedResultVariables = {
  headers?: AsyncAnalyzedResultHeaders
  pathParams: AsyncAnalyzedResultPathParams
} & DocumentAiContext['fetcherOptions']

/**
 * Get the result of the document analyze
 */
export const fetchAsyncAnalyzedResult = (variables: AsyncAnalyzedResultVariables, signal?: AbortSignal) =>
  documentAiFetch<
    Schemas.Document,
    AsyncAnalyzedResultError,
    undefined,
    AsyncAnalyzedResultHeaders,
    {},
    AsyncAnalyzedResultPathParams
  >({
    url: '/documents/{documentId}/uploaded/analyzeResult/{operationId}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Get the result of the document analyze
 */
export const useAsyncAnalyzedResult = <TData = Schemas.Document>(
  variables: AsyncAnalyzedResultVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Document, AsyncAnalyzedResultError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDocumentAiContext(options)
  return reactQuery.useQuery<Schemas.Document, AsyncAnalyzedResultError, TData>({
    queryKey: queryKeyFn({
      path: '/documents/{documentId}/uploaded/analyzeResult/{operationId}',
      operationId: 'asyncAnalyzedResult',
      variables,
    }),
    queryFn: ({ signal }) => fetchAsyncAnalyzedResult({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DocumentListQueryParams = {
  /**
   * Posizione primo elemento da ritornare per la pagina di risultati corrente
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Numero di righe massimo per la pagina di risultati
   *
   * @format int32
   * @default 20
   * @minimum 1
   * @maximum 50
   */
  pagingLimit?: number
  name?: string
  /**
   * document associated to entity
   */
  entityId?: string
  status?: Schemas.DocumentStatus[]
  type?: Schemas.DocumentType[]
  scope?: string[]
}

export type DocumentListHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentListError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentListVariables = {
  headers?: DocumentListHeaders
  queryParams?: DocumentListQueryParams
} & DocumentAiContext['fetcherOptions']

/**
 * Returns all the documents
 */
export const fetchDocumentList = (variables: DocumentListVariables, signal?: AbortSignal) =>
  documentAiFetch<Schemas.DocumentPaginated, DocumentListError, undefined, DocumentListHeaders, DocumentListQueryParams, {}>({
    url: '/documents',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns all the documents
 */
export const useDocumentList = <TData = Schemas.DocumentPaginated>(
  variables: DocumentListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DocumentPaginated, DocumentListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDocumentAiContext(options)
  return reactQuery.useQuery<Schemas.DocumentPaginated, DocumentListError, TData>({
    queryKey: queryKeyFn({
      path: '/documents',
      operationId: 'documentList',
      variables,
    }),
    queryFn: ({ signal }) => fetchDocumentList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DocumentCreateHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentCreateError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentCreateVariables = {
  body: Schemas.DocumentCreateRequest
  headers?: DocumentCreateHeaders
} & DocumentAiContext['fetcherOptions']

/**
 * Create Document Request
 */
export const fetchDocumentCreate = (variables: DocumentCreateVariables, signal?: AbortSignal) =>
  documentAiFetch<Schemas.CreateResponse, DocumentCreateError, Schemas.DocumentCreateRequest, DocumentCreateHeaders, {}, {}>({
    url: '/documents',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Create Document Request
 */
export const useDocumentCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.CreateResponse, DocumentCreateError, DocumentCreateVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useDocumentAiContext()
  return reactQuery.useMutation<Schemas.CreateResponse, DocumentCreateError, DocumentCreateVariables>({
    mutationFn: (variables: DocumentCreateVariables) => fetchDocumentCreate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type DocumentsDeleteQueryParams = {
  /**
   * The ids of the documents to delete, semicolon separated.
   */
  ids: string[]
}

export type DocumentsDeleteHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentsDeleteError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Responses.ErrorBadRequest
}>

export type DocumentsDeleteVariables = {
  headers?: DocumentsDeleteHeaders
  queryParams: DocumentsDeleteQueryParams
} & DocumentAiContext['fetcherOptions']

/**
 * Deletes the documents specified by the ids. It is possible to delete only the documents not already locked. The ids are semicolon separated. The maximum number of ids is 100.
 */
export const fetchDocumentsDelete = (variables: DocumentsDeleteVariables, signal?: AbortSignal) =>
  documentAiFetch<undefined, DocumentsDeleteError, undefined, DocumentsDeleteHeaders, DocumentsDeleteQueryParams, {}>({
    url: '/documents',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * Deletes the documents specified by the ids. It is possible to delete only the documents not already locked. The ids are semicolon separated. The maximum number of ids is 100.
 */
export const useDocumentsDelete = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, DocumentsDeleteError, DocumentsDeleteVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useDocumentAiContext()
  return reactQuery.useMutation<undefined, DocumentsDeleteError, DocumentsDeleteVariables>({
    mutationFn: (variables: DocumentsDeleteVariables) => fetchDocumentsDelete({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type DocumentGetPathParams = {
  documentId: string
}

export type DocumentGetHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentGetError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentGetVariables = {
  headers?: DocumentGetHeaders
  pathParams: DocumentGetPathParams
} & DocumentAiContext['fetcherOptions']

/**
 * Returns the details of the document
 */
export const fetchDocumentGet = (variables: DocumentGetVariables, signal?: AbortSignal) =>
  documentAiFetch<Schemas.Document, DocumentGetError, undefined, DocumentGetHeaders, {}, DocumentGetPathParams>({
    url: '/documents/{documentId}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the details of the document
 */
export const useDocumentGet = <TData = Schemas.Document>(
  variables: DocumentGetVariables,
  options?: Omit<reactQuery.UseQueryOptions<Schemas.Document, DocumentGetError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDocumentAiContext(options)
  return reactQuery.useQuery<Schemas.Document, DocumentGetError, TData>({
    queryKey: queryKeyFn({
      path: '/documents/{documentId}',
      operationId: 'documentGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchDocumentGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DocumentUpdatePathParams = {
  documentId: string
}

export type DocumentUpdateHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentUpdateError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
  | {
      status: 405
      payload: Responses.ErrorMethodNotAllowed
    }
>

export type DocumentUpdateVariables = {
  body?: Schemas.DocumentUpdateRequest
  headers?: DocumentUpdateHeaders
  pathParams: DocumentUpdatePathParams
} & DocumentAiContext['fetcherOptions']

/**
 * Update Document Request
 */
export const fetchDocumentUpdate = (variables: DocumentUpdateVariables, signal?: AbortSignal) =>
  documentAiFetch<
    Schemas.Document,
    DocumentUpdateError,
    Schemas.DocumentUpdateRequest,
    DocumentUpdateHeaders,
    {},
    DocumentUpdatePathParams
  >({ url: '/documents/{documentId}', method: 'put', ...variables, signal })

/**
 * Update Document Request
 */
export const useDocumentUpdate = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.Document, DocumentUpdateError, DocumentUpdateVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useDocumentAiContext()
  return reactQuery.useMutation<Schemas.Document, DocumentUpdateError, DocumentUpdateVariables>({
    mutationFn: (variables: DocumentUpdateVariables) => fetchDocumentUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type DocumentDeletePathParams = {
  documentId: string
}

export type DocumentDeleteHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentDeleteError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Responses.ErrorBadRequest
}>

export type DocumentDeleteVariables = {
  headers?: DocumentDeleteHeaders
  pathParams: DocumentDeletePathParams
} & DocumentAiContext['fetcherOptions']

/**
 * Deletes the document specified by the id. It is possible to delete only document if it is not already associated to an entityId or locked.
 */
export const fetchDocumentDelete = (variables: DocumentDeleteVariables, signal?: AbortSignal) =>
  documentAiFetch<undefined, DocumentDeleteError, undefined, DocumentDeleteHeaders, {}, DocumentDeletePathParams>({
    url: '/documents/{documentId}',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * Deletes the document specified by the id. It is possible to delete only document if it is not already associated to an entityId or locked.
 */
export const useDocumentDelete = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, DocumentDeleteError, DocumentDeleteVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useDocumentAiContext()
  return reactQuery.useMutation<undefined, DocumentDeleteError, DocumentDeleteVariables>({
    mutationFn: (variables: DocumentDeleteVariables) => fetchDocumentDelete({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type DocumentFileGetPathParams = {
  documentId: string
}

export type DocumentFileGetHeaders = {
  /**
   * The membership id of the logged in user
   */
  ['X-Membershipid']?: string
}

export type DocumentFileGetError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentFileGetVariables = {
  headers?: DocumentFileGetHeaders
  pathParams: DocumentFileGetPathParams
} & DocumentAiContext['fetcherOptions']

/**
 * Returns the link for access to the file of the document
 */
export const fetchDocumentFileGet = (variables: DocumentFileGetVariables, signal?: AbortSignal) =>
  documentAiFetch<undefined, DocumentFileGetError, undefined, DocumentFileGetHeaders, {}, DocumentFileGetPathParams>({
    url: '/documents/{documentId}/file',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the link for access to the file of the document
 */
export const useDocumentFileGet = <TData = undefined>(
  variables: DocumentFileGetVariables,
  options?: Omit<reactQuery.UseQueryOptions<undefined, DocumentFileGetError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDocumentAiContext(options)
  return reactQuery.useQuery<undefined, DocumentFileGetError, TData>({
    queryKey: queryKeyFn({
      path: '/documents/{documentId}/file',
      operationId: 'documentFileGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchDocumentFileGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation =
  | {
      path: '/documents/{documentId}/uploaded/analyzeResult/{operationId}'
      operationId: 'asyncAnalyzedResult'
      variables: AsyncAnalyzedResultVariables
    }
  | {
      path: '/documents'
      operationId: 'documentList'
      variables: DocumentListVariables
    }
  | {
      path: '/documents/{documentId}'
      operationId: 'documentGet'
      variables: DocumentGetVariables
    }
  | {
      path: '/documents/{documentId}/file'
      operationId: 'documentFileGet'
      variables: DocumentFileGetVariables
    }
